import axios from "axios"
import qs from 'qs'
import {config, GA_LOCAL_STORAGE_KEY, izNotBlank} from "../constants"
import CustomerService from "./customer.service";
import ReportService from "./report.service";
import CommonService from "./common.service";

class AuthService {

    login(email, password) {

        return axios.post(
            config.AUTH_URL + "token",
            qs.stringify({
                'username': email,
                'password': password,
                'grant_type': 'password'
            }),
            {
                headers: {
                    'client-id': 'searchsanctions-ui',
                    'client-secret': 'searchsanctions-ui-secret',
                    // 'Authorization': 'Basic c2VhcmNoc2FuY3Rpb25zOkthbWlsS2FtaWxvdkA2OQ==',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
    }

    sendVerificationCode(email) {
        return axios.post(
            config.AUTH_URL + "user/reset-pass/verification-code",
            null,
            {
                params: {
                    email: email
                }
            })
    }

    register(user) {
        return axios.post(
            config.AUTH_URL + "user/register",
            user,
            {
                params: {
                    lang: CommonService.getLang()
                }
            })
    }

    checkToken(token, lang) {
        return axios.post(
            config.AUTH_URL + "user/registration-confirm",
            null,
            {
                params: {
                    token: token,
                    lang: lang
                }
            })
    }

    resetPassword(email, verificationCode, password) {
        return axios.post(
            config.AUTH_URL + "user/reset-pass",
            null,
            {
                params: {
                    email, verificationCode, password
                }
            })
    }

    resendRegistrationToken(existingToken, lang) {
        return axios.post(
            config.AUTH_URL + "user/resend-registration-token",
            null,
            {
                params: {
                    existingToken: existingToken,
                    lang: lang
                }
            })
    }

    logout() {
        this.removeUser();
        this.removeRefCode();
        ReportService.removeSearchId();
        CustomerService.removeCustomerNoFromTx();
    }

    removeUser() {
        localStorage.removeItem("user")
    }

    saveUser(user) {
        localStorage.setItem("user", JSON.stringify(user))

        this.removeRefCode();
    }

    getCurrentUser() {
        return JSON.parse(localStorage.getItem('user'))
    }

    updateUserLang(lang, authHeader) {
        return axios.put(
            config.AUTH_URL + "user/update-user-lang/" + lang,
            {},
            {headers: authHeader()})
    }

    hasRole(role) {
        const currentUser = this.getCurrentUser();
        const isAuthenticated = currentUser && izNotBlank(currentUser.accessToken);

        return isAuthenticated && currentUser.roles.includes(role);
    }

    getGAClientId() {
        return JSON.parse(localStorage.getItem(GA_LOCAL_STORAGE_KEY))
    }

    getCurrentUserUniqueId() {
        let currentUser = this.getCurrentUser()

        return currentUser ? currentUser.uniqueKey : this.getGAClientId()
    }

    isAuthenticated() {
        let currentUser = this.getCurrentUser();
        return currentUser && currentUser.accessToken && currentUser.accessToken !== ""
    }

    saveRefCode(refCode) {
        localStorage.setItem("refCode", refCode)
    }

    getRefCode() {
        return localStorage.getItem("refCode")
    }

    removeRefCode() {
        localStorage.removeItem("refCode")
    }

}

export default new AuthService();
